<template>
  <v-container fluid class="down-top-padding">
    <v-row>
      <v-col cols="12" lg="12">
        <v-card>
          <v-toolbar flat>
            <v-col cols="12" class="px-0">
              <div class="d-flex align-center">
                <div class="text-left">
                  <v-toolbar-title class="page-title">
                    List of Banks
                  </v-toolbar-title>
                </div>
                <div class="ml-auto">
                  <v-btn color="primary" @click="addBank()">
                    <v-icon class="mr-2">mdi-plus</v-icon> Add
                  </v-btn>
                </div>
              </div>
            </v-col>
            <v-spacer></v-spacer>
          </v-toolbar>

          <v-divider></v-divider>
          <v-card-title>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table
            :headers="table.headers"
            :items="table.data"
            :items-per-page="10"
            :loading="table.loading"
            item-key="id"
            :search="search"
            loading-text="Loading... Please wait"
            class="elevation-1"
          >
            <template
              v-for="header in table.headers.filter((header) =>
                header.hasOwnProperty('formatter')
              )"
              v-slot:[`item.${header.value}`]="{ value }"
            >
              {{ header.formatter(value) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <AddBankDialog ref="addBankDialog" />
  </v-container>
</template>

<script>
// import moment from "moment";
import AddBankDialog from "../dialogs/distributor/AddBankDialog";
import ShareableMethods from "@/mixins/ShareableMethods";
export default {
  name: "DistributorDealerList",
  mixins: [ShareableMethods],
  components: {
    AddBankDialog,
  },
  data() {
    return {
      search: "",
      table: {
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Bank Name",
            value: "name",
          },

          {
            text: "Account Name",
            value: "accountName",
            sortable: false,
          },

          {
            text: "Account Number",
            value: "accountNumber",
            sortable: false,
          },

          {
            text: "Account Type",
            value: "accountType",
            sortable: false,
          },

          // {
          //   text: "Mobile Number",
          //   value: "emailAddress",
          //   sortable: false,
          // },

          // {
          //   text: "Added By",
          //   value: "addedBy",
          //   sortable: false,
          // },
        ],
        data: [],
      },
      // DID: {
      //   distributorId: "",
      // },
    };
  },
  methods: {
    async getList() {
      this.table.loading = true;
      const { adminLogin } = this.userData;

      // const endPoint = this.getLabel(
      //   this.getDashboardRole.code,
      //   this.$dd_verifier,
      //   "verified-dealers",
      //   "approved-dealers"
      // );

      // this.DID.distributorId = this.$store.getters.distributorId;

      await this.$drs
        .get(
          `/broker/drs/distributor-banks?distributorId=${adminLogin.distributorId}`
        )
        .then((response) => {
          const newArr = response.data.data;
          this.table.data = newArr.list;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async addBank() {
      await this.$refs.addBankDialog.open().then((result) => {
        if (result) {
          this.getList();
        }
      });
    },
  },
  created() {
    this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    getDashboardRole() {
      return this.$store.getters.dashboardRole;
    },

    userData() {
      return this.$store.getters.userData;
    },
  },
};
</script>
